module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-208.0328a9b.woff2";